import { FC } from 'react';
import clsx from 'clsx';
import styles from './FilterOptionFieldsGroup.module.scss';
import { FilterOptionField } from './FilterOptionField';
import {
  FilterItemProps,
  FilterOption,
  PlpFiltersConditionalProps,
} from 'src/plp/components/PlpFilters/PlpFilters.type';

type Props = {
  currentFilters: FilterOption[];
  options: FilterItemProps[];
} & PlpFiltersConditionalProps;

export const FilterOptionFieldsGroup: FC<Props> = ({ currentFilters, options, ...props }) => {
  return (
    <div className={clsx(styles.rootOptionsGroup, 'wrapper', 'wrapper--checkbox')}>
      {options.map((option) => (
        <FilterOptionField
          {...option}
          checked={currentFilters.some((filter) => filter.value === option.value && filter.filter === option.filter)}
          key={option.value}
          {...props}
        />
      ))}
    </div>
  );
};
